import React, { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import api, { fileUrl } from "@/api";
import { useLang } from "@/context/LanguageContext";

/**
 * Auto-shown offer/scheme popup for shopkeepers.
 * Shows once per day per popup. Closing marks it seen for today.
 */
export default function OfferPopup() {
  const { t } = useLang();
  const [popup, setPopup] = useState(null);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    api.get("/popups/active")
      .then(r => { if (r.data.popup) setPopup(r.data.popup); })
      .catch(() => {});
  }, []);

  const close = async () => {
    if (!popup) return;
    setClosing(true);
    try { await api.post(`/popups/${popup.id}/seen`); } catch (_) {}
    setPopup(null);
  };

  if (!popup) return null;

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-md z-[100] grid place-items-center p-4 fade-up"
      data-testid="offer-popup"
    >
      <div className="relative w-full max-w-md sm:max-w-lg">
        <button
          onClick={close}
          disabled={closing}
          data-testid="offer-popup-close"
          className="absolute -top-3 -right-3 z-10 w-11 h-11 rounded-full bg-white shadow-xl grid place-items-center hover:bg-rose-50 transition active:scale-95"
          aria-label={t("close")}
          title={t("close")}
        >
          <X className="w-6 h-6 text-[#1D1D1F]" strokeWidth={2.5} />
        </button>
        <div className="bg-white rounded-3xl overflow-hidden soft-shadow-md">
          {popup.title && (
            <div className="px-5 py-3 border-b border-gray-100 flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-[#0055FF]" />
              <div className="heading-font font-bold text-[#1D1D1F] truncate">{popup.title}</div>
            </div>
          )}
          <div className="bg-black grid place-items-center" style={{ minHeight: 240 }}>
            {popup.media_type === "video" ? (
              <video
                src={fileUrl(popup.media_path)}
                autoPlay
                muted
                loop
                playsInline
                controls
                className="w-full max-h-[70vh] object-contain"
                data-testid="offer-popup-video"
              />
            ) : (
              <img
                src={fileUrl(popup.media_path)}
                alt={popup.title || t("offer")}
                className="w-full max-h-[70vh] object-contain"
                data-testid="offer-popup-image"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
